import { Commit, StoreOptions } from 'vuex';
import Cookies from 'js-cookie';
import smh, { SMH } from '@/renderer/scripts/smh';
import { encodeText, decodeText } from '@/renderer/scripts/utils/tools/index';
export interface ShareState {
  shareToken: string;
  extractCode: string;
  cookieShareToken: string;
  detail: {
    loading: boolean;
    name: string;
    needExtractionCode: boolean;
    userId: number;
    userAvatar: string;
    userNickname: string;
    expireTime: string;
    canSaveToNetDisc: boolean;
    isPermanent: boolean | undefined;
    enableShareWatermark: boolean;
    shareWatermarkType: number;
    phoneNumberSuffix: string;
    orgName: string;
    orgLogo: string;
    showOrgNameInUI: boolean | undefined;
  };
}
interface ActionParam {
  commit: Commit;
  state: ShareState;
}

/**
 * 共享外链界面使用，
 */
const share: StoreOptions<ShareState> = {
  state: {
    shareToken: '',
    cookieShareToken: '',
    extractCode: '',
    detail: {
      loading: true,
      name: '',
      needExtractionCode: true,
      userId: -1,
      userAvatar: '',
      userNickname: '',
      expireTime: '',
      canSaveToNetDisc: false,
      isPermanent: undefined,
      enableShareWatermark: false,
      shareWatermarkType: 1,
      phoneNumberSuffix: '',
      orgName: '',
      orgLogo: '',
      showOrgNameInUI: false,
    },
  },
  mutations: {
    SET_SHARE_ID(state: ShareState, token: string): void {
      state.shareToken = token;
    },
    SET_SHARE_LINK_DETAIL(state: ShareState, detail: ShareState['detail']): void {
      state.detail.name = detail.name;
      state.detail.needExtractionCode = detail.needExtractionCode;
      state.detail.userAvatar = detail.userAvatar;
      state.detail.userNickname = detail.userNickname;
      state.detail.expireTime = detail.expireTime;
      state.detail.userId = detail.userId;
      state.detail.canSaveToNetDisc = detail.canSaveToNetDisc;
      state.detail.isPermanent = detail.isPermanent;
      state.detail.enableShareWatermark = detail.enableShareWatermark;
      state.detail.shareWatermarkType = detail.shareWatermarkType;
      state.detail.phoneNumberSuffix = detail.phoneNumberSuffix;
      state.detail.orgName = detail.orgName;
      state.detail.orgLogo = detail.orgLogo;
      state.detail.showOrgNameInUI = detail.showOrgNameInUI;
    },
    SET_EXTRACT_CODE(state: ShareState, code: string): void {
      state.extractCode = code;
      const extractDetail = encodeText(
        JSON.stringify({
          shareToken: state.shareToken,
          code,
        }),
      );
      if (code) {
        Cookies.set('EXTRACT_CODE', extractDetail, {
          expires: 1,
        });
      } else {
        Cookies.remove('EXTRACT_CODE');
      }
    },
    RESET_SHARE_LINK_DETAIL(state: ShareState, detail: ShareState['detail']): void {
      Object.assign(state.detail, {
        loading: true,
        name: '',
        needExtractionCode: true,
        userId: -1,
        userAvatar: '',
        userNickname: '',
        expireTime: '',
        canSaveToNetDisc: false,
      });
    },
  },
  getters: {
    needExtractionCode(state: ShareState): boolean {
      return state.detail.needExtractionCode;
    },
    shareId(state: ShareState): string {
      return state.shareToken;
    },
    cookieShareToken(state: ShareState): string {
      if (!state.cookieShareToken) {
        let extractDetail: any = Cookies.get('EXTRACT_CODE')
          ? decodeText(Cookies.get('EXTRACT_CODE') as string)
          : undefined;
        if (extractDetail) {
          extractDetail = JSON.parse(extractDetail);
        }
        state.cookieShareToken = extractDetail?.shareToken || '';
      }
      return state.cookieShareToken;
    },
    extractCode(state: ShareState): string {
      if (!state.extractCode) {
        let extractDetail: any =
          state.cookieShareToken === state.shareToken && Cookies.get('EXTRACT_CODE')
            ? decodeText(Cookies.get('EXTRACT_CODE') as string)
            : undefined;
        if (extractDetail) {
          extractDetail = JSON.parse(extractDetail);
        }
        state.extractCode = extractDetail?.code || '';
      }
      return state.extractCode;
    },
    canSaveToNetDisc(state: ShareState): boolean {
      return state.detail.canSaveToNetDisc;
    },
  },
  actions: {
    async GetSharedLinkDetail(
      { commit, state }: ActionParam,
      shareToken: string,
    ): Promise<SMH.GetSharedLinkDetailData> {
      state.detail.loading = true;
      commit('SET_SHARE_ID', shareToken);
      const { data } = await smh.userAPI.getSharedLinkDetail({
        shareToken,
      });
      state.detail.loading = false;
      commit('SET_SHARE_LINK_DETAIL', data);
      return data;
    },
  },
};
export default share;
